<div class="container container-shadow pt-4 pb-5 my-4 mb-4" id="main-content">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div></div>
    <h2 class="text-center mb-0">Activity Matter Rate {{ activityMatterRate?.id }}</h2>
    <button *ngIf="!editing" type="button" class="btn btn-primary" (click)="edit()">Edit</button>
  </div>
  <h3 class="text-center"></h3>
  <div *ngIf="saveError" class="alert alert-danger">{{ saveError }}</div>
  <table class="table table-striped">
    <thead>
      <tr>
        <th></th>
        <th class="center">Name</th>
        <th class="center">ID</th>
        <th class="center">Billings<br>Count</th>
        <th class="center">Matter<br>Count</th>
      </tr>
    </thead>
    <tbody>
      <tr class="center">
        <td>Activity:</td>
        <td class="center">{{ activityMatterRate?.activity?.name }}</td>
        <td class="center">{{ activityMatterRate?.activity_id }}</td>
        <td class="center">{{ activityMatterRate?.activity?.activity_billing_count }}</td>
        <td class="center">{{ activityMatterRate?.activity?.activity_matter_count }}</td>
      </tr>
      <tr class="center">
        <td>Matter Type:</td>
        <td class="center">{{ activityMatterRate?.matter_type?.name || 'GLOBAL' }}</td>
        <td class="center">{{ activityMatterRate?.matter_type_id }}</td>
        <td class="center">{{ activityMatterRate?.matter_type?.matter_type_billing_count }}</td>
        <td class="center">{{ activityMatterRate?.matter_type?.matter_type_matter_count }}</td>
      </tr>
      <tr class="center">
        <td>Rate Type:</td>
        <td class="center">
          <span *ngIf="!editing">{{ activityMatterRate?.rate_type?.name }}</span>
          <select *ngIf="editing" class="form-control rate-type-select" [(ngModel)]="form.rate_type_id">
            <option *ngFor="let rateType of activityMatterRate?.rate_types" [ngValue]="rateType.id">
              {{ rateType.name }}
            </option>
          </select>
        </td>
        <td class="center">{{ activityMatterRate?.rate_type_id }}</td>
        <td class="center">{{ activityMatterRate?.rate_type?.rate_type_billing_count }}</td>
        <td class="center">{{ activityMatterRate?.rate_type?.rate_type_matter_count }}</td>
      </tr>
      <tr class="center">
        <td>Rate:</td>
        <td class="center">
          <span *ngIf="!editing">{{ activityMatterRate?.rate_display || activityMatterRate?.rate }}</span>
          <input
            *ngIf="editing"
            type="number"
            step="0.01"
            class="form-control rate-input"
            [(ngModel)]="form.rate"
          >
        </td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr class="center">
        <td>Is Global?:</td>
        <td class="center">
          <span *ngIf="!editing">{{ activityMatterRate?.is_global ? 'Yes' : 'No' }}</span>
          <label *ngIf="editing" class="global-checkbox">
            <input type="checkbox" [(ngModel)]="form.is_global">
            Global
          </label>
        </td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="editing" class="d-flex justify-content-end">
    <button type="button" class="btn btn-secondary mr-2" (click)="cancel()" [disabled]="saving">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">
      {{ saving ? 'Saving...' : 'Save' }}
    </button>
  </div>
</div>
